import React from "react";
import { ArrowRight, Cpu } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { TechLines } from "../components/site/TechLines";
import { AI_SERVICES, IMAGES } from "../data/content";

export const AIDigital = () => {
  const go = (h) => document.querySelector(h)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="ai-digital" className="relative overflow-hidden emerald-radial py-24 text-off-white sm:py-32" data-testid="ai-digital-section">
      <TechLines className="opacity-60" />
      <div className="grain absolute inset-0" />
      <div className="relative z-10 mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <Reveal><Overline dark>AI, Data & Digital Transformation</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
              Turning Technology into <span className="text-gradient-gold">Business Advantage</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-off-white/70 sm:text-lg">
              OnwardTranscends helps organisations responsibly integrate digital technologies, automation, data analytics
              and artificial intelligence into everyday operations.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
              {AI_SERVICES.map((a) => (
                <div key={a} className="flex items-center gap-2.5 text-sm text-off-white/85">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-light" /> {a}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <button data-testid="ai-cta-btn" onClick={() => go("#contact")}
              className="group mt-10 flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-semibold text-emerald-darkest transition-transform duration-300 hover:-translate-y-1">
              <Cpu size={18} /> Discover AI & Digital Transformation
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl">
            <img src={IMAGES.aiDigital} alt="AI robot interacting with analytics dashboards" className="w-full object-cover transition-transform duration-700 hover:scale-105" />
            <div className="glass absolute bottom-5 left-5 right-5 rounded-2xl p-5">
              <p className="text-xs font-bold uppercase tracking-widest text-gold-light">Human + Machine</p>
              <p className="mt-1 font-serif text-xl">Intelligent automation, responsibly delivered.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
